import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var FILTER_SINGLESELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return FilterSingleSelectComponent; }),
    multi: true,
};
var FilterSingleSelectComponent = /** @class */ (function () {
    function FilterSingleSelectComponent(elementRef) {
        this.elementRef = elementRef;
        /**
         * Since this is a control with static values, data is the array of filter options.
         */
        this.data = [];
        /**
         * Event - Fires when an option gets selected.
         */
        this.filterChanges = new EventEmitter();
        /**
         * The state of the dropdown.
         */
        this.isOpen = false;
        /**
         * ControlValueAccessor Interface and mutator:
         * => placeholder for the onChange callback which is later provided by the Control Value Accessor
         */
        this.onChangeCallback = function (_) { };
        /**
         * ControlValueAccessor Interface and mutator:
         * => placeholder for the onTouched callback which is later provided by the Control Value Accessor
         */
        this.onTouchedCallback = function (_) { };
        // Setting the value accessor directly (instead of using
        // the providers) to avoid running into a circular import.
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }
    /**
     * Implementation of Angular's OnInit lifecycle hook
     */
    FilterSingleSelectComponent.prototype.ngOnInit = function () {
        if (this.data) {
            var selectedItem = this.data.find(function (item) { return item.value !== null; });
            if (selectedItem) {
                selectedItem.checked = true;
                this.innerValue = selectedItem.id;
            }
        }
        this.setFilterLabelAndPlaceholder();
    };
    /**
     * From ControlValueAccessor interface:
     * Writes value from model to view in one of the following cases:
     * - when a new form control is instantiated
     * - when you call this.control.patchValue() or this.control.setValue()
     *
     * @param value
     */
    FilterSingleSelectComponent.prototype.writeValue = function (value) {
        var _this = this;
        // update selected item
        if (this.data) {
            this.data.forEach(function (item) {
                if (item.name === value) {
                    item.checked = true;
                    _this.innerValue = item.id;
                }
                else {
                    item.checked = false;
                }
            });
        }
    };
    /**
     * Sets label and placeholder.
     */
    FilterSingleSelectComponent.prototype.setFilterLabelAndPlaceholder = function () {
        if (!this.label && this.placeholder) {
            this.label = this.placeholder;
        }
        if (this.label && !this.placeholder) {
            this.placeholder = this.label;
        }
    };
    /**
     * From ControlValueAccessor interface:
     * This function is called when the control status changes to or from DISABLED.
     * Depending on the value, it will enable or disable the appropriate DOM element.
     *
     * Angular will call this method in one of the following cases:
     * - when you instantiate a new FormControl with the disabled property set to true,
     *   e.g. FormControl({value:'', disabled: true})
     * - when you call control.disable() or control.enable() after you already called control.disbale() at least once.
     * @param isDisabled
     */
    FilterSingleSelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * From ControlValueAccessor interface:
     * Set the function to be called when the control receives a change event.
     * Angular provides you with a function and asks you to call it whenever there
     * is a change in your component with the new value so that it can update the
     * control.
     * @param fn
     */
    FilterSingleSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    /**
     * Set the function to be called when the control receives a blur event.
     * Angular provides you with a function and asks you to call it when the
     * component loses focus in order to update the control with the new value.
     *
     * @param fn
     */
    FilterSingleSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    /**
     * Event - Fires when a click happens on the document.
     * If the click was outside of the control, the dropdown should close
     * @param event
     */
    FilterSingleSelectComponent.prototype.onHostClick = function (event) {
        if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    };
    /**
     * Event - Fires, when control value changes
     * @param event
     */
    FilterSingleSelectComponent.prototype.onHostChange = function (event) {
        this.onChangeCallback(this.innerValue);
    };
    /**
     * Event - Fires when the filter selection is confirmed.
     */
    FilterSingleSelectComponent.prototype.onFilterChange = function (item) {
        this.writeValue(item);
        this.setFilterLabelAndPlaceholder();
        this.onChangeCallback(this.innerValue);
        this.filterChanges.emit(this.innerValue);
    };
    Object.defineProperty(FilterSingleSelectComponent.prototype, "selected", {
        get: function () {
            return this.innerValue;
        },
        enumerable: true,
        configurable: true
    });
    FilterSingleSelectComponent.decorators = [
        { type: Component, args: [{
                    host: {
                        '(change)': 'onHostChange($event)',
                        '(document:click)': 'onHostClick($event)',
                    },
                    providers: [FILTER_SINGLESELECT_VALUE_ACCESSOR],
                    selector: 'cov-filter-singleselect',
                    template: "<div class=\"m-filter-singleselect {{ modifier && 'm-filter-singleselect--' + modifier || modifier }}\"\r\n\t data-t-name=\"FilterSingleSelect\"\r\n\t [attr.data-t-decorator]=\"decorator\">\r\n\t<div>\r\n\t\t<select (change)=\"onFilterChange($event.target.value)\">\r\n\t\t\t<option\r\n\t\t\t\t[ngValue]=\"item.itemId\"\r\n\t\t\t\t[innerHtml]=\"item.name\"\r\n\t\t\t\t[selected]=\"item.checked\"\r\n\t\t\t\t*ngFor=\"let item of data\">\r\n\t\t\t</option>\r\n\t\t</select>\r\n\t</div>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    FilterSingleSelectComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    FilterSingleSelectComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        label: [{ type: Input }],
        placeholder: [{ type: Input }],
        data: [{ type: Input }],
        disabled: [{ type: Input }],
        filterChanges: [{ type: Output }]
    };
    return FilterSingleSelectComponent;
}());
export { FilterSingleSelectComponent };
//# sourceMappingURL=filter-singleselect.component.js.map